export default {
    serviceList: [
    ],
}
